function Footer() {
    return (
        <div className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Copyright &copy; Telecons 2023</span>
                </div>
            </div>
        </div>
    );
}

export default Footer;